export const basePath = '/membership/make-a-payment/';
export const autoPayPath = '/membership/autopay-enrollment/';
